import CleanedContent from "~/components/atoms/CleanedContent";
import Typo from "~/components/atoms/Typo";
import { ETypoColor } from "~/utilities/enums/Colors";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

export interface CardProjectInfoProps {
  name: string;
  description: string;
}

export default function CardProjectInfo({
  name,
  description,
}: CardProjectInfoProps) {
  return (
    <div className="flex flex-col gap-6 rounded-xl px-0 py-6 lg:gap-5 lg:rounded-lg lg:px-6 lg:py-4.5">
      <Typo
        className="font-bold"
        tag={ETypoTag.H3}
        color={ETypoColor.PROJECT_HEADING}
        variant={ETypoVariant.HEADER_PROJECT_24}
      >
        {name}
      </Typo>
      <CleanedContent
        htmlContent={description}
        className="h-full w-full text-body-title-16 text-color"
      />
    </div>
  );
}
